import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import t2payService from "@/services/t2pay.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveBankAccount = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (bankAccountId) => t2payService.deleteBankAccount(bankAccountId),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveBankAccount;
